import React from 'react';
import axios from 'axios';
import { user_token } from '../../../services/Auth';
import { NavLink } from 'react-router-dom';

var token = localStorage.getItem(user_token);

export default class GetExam extends React.Component {
  state = {
    user: [],
    first: true,
  }

  componentDidMount() {
    axios.get(`http://api-convida.herokuapp.com/user/${this.props._id}`, {headers: {'x-access-token': token}})
      .then(res => {
        const user = res.data;
        this.setState({ user });
      })
  }

  render() {
    let {first} = this.state;
    const renderAuthButton = ()=>{
      if(first){
        return <NavLink to={{pathname: `/prontuario_inicial/${this.props._id}`}}>
        <button id="option-PS-Painel">Fazer Prescrição</button></NavLink>
      } else{
        return <NavLink to={{pathname: `/monitoramento/${this.props._id}`}}>
        <button id="option-PS-Painel">Fazer Prescrição</button></NavLink>
      }
    }
    return (
      <ul>
        { this.state.user.map(details => 
        <>
          {renderAuthButton()}
        </>)}
      </ul>
    )
  }
}